import React, { useState, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

function RegistrationForm({ onRegister, onSwitchToLogin }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const recaptchaRef = useRef();
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/register/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, email, captchaToken })
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data?.username?.[0] || data?.email?.[0] || data?.password?.[0] || 'Ошибка регистрации');
        setLoading(false);
        return;
      }
      // После успешной регистрации сразу логиним пользователя
      const loginRes = await fetch(`${API_URL}/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      if (!loginRes.ok) {
        setError('Регистрация прошла, но вход не был выполнен');
        setLoading(false);
        return;
      }
      const loginData = await loginRes.json();
      localStorage.setItem('access_token', loginData.access);
      localStorage.setItem('refresh_token', loginData.refresh);
      onRegister && onRegister();
    } catch (err) {
      setError('Ошибка сети');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 340, margin: '40px auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <input
        type="text"
        placeholder="Логин"
        value={username}
        onChange={e => setUsername(e.target.value)}
        required
        autoFocus
      />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
      />
      <input
        type="password"
        placeholder="Пароль"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
      />
      <ReCAPTCHA
        sitekey="6Lc-Aj8rAAAAAElJnBchsefSVgBfiTjALOVV1K7y"
        ref={recaptchaRef}
        onChange={setCaptchaToken}
      />
      <button type="submit" disabled={!captchaToken || loading}>{loading ? 'Регистрируем...' : 'Зарегистрироваться'}</button>
      <button type="button" onClick={onSwitchToLogin} style={{ background: 'none', color: '#2980b9', border: 'none', cursor: 'pointer', marginTop: 4 }}>
        Уже есть аккаунт? Войти
      </button>
      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}
    </form>
  );
}

export default RegistrationForm; 